export const ORGANIZATIONS_ACTION_TYPES = {
    LIST_REQUEST: "ORGANIZATIONS_LIST_REQUEST",
    LIST_SUCCESS: "ORGANIZATIONS_LIST_SUCCESS",
    LIST_FAILURE: "ORGANIZATIONS_LIST_FAILURE",
    SELECT: "ORGANIZATIONS_SELECT",
    DETAIL_REQUEST: "ORGANIZATIONS_DETAIL_REQUEST",
    DETAIL_SUCCESS: "ORGANIZATIONS_DETAIL_SUCCESS",
    DETAIL_FAILURE: "ORGANIZATIONS_DETAIL_FAILURE",
    AVAILABLE_LOCATIONS_REQUEST: "ORGANIZATIONS_AVAILABLE_LOCATIONS_REQUEST",
    AVAILABLE_LOCATIONS_SUCCESS: "ORGANIZATIONS_AVAILABLE_LOCATIONS_SUCCESS",
};
